<template>
  <div>
    <div v-if="!isLongText || hideButtons">
      {{ isLongText && hideButtons ? truncatedText : text }}
    </div>
    <div v-else>
      <div v-if="!isExpanded">
        {{ truncatedText }}
        <button class="text-blue text-xs" type="button" @click="toggleExpanded">
          {{ $t('common.show-more') }}
        </button>
      </div>
      <div v-else>
        {{ text }}
        <button class="text-blue text-xs" type="button" @click="toggleExpanded">
          {{ $t('common.show-less') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandableText',
  props: {
    text: {
      type: String,
      required: true,
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    hideButtons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    isLongText() {
      return this.text.length > this.maxLength;
    },
    truncatedText() {
      if (!this.isLongText) return this.text;
      return this.text.substring(0, this.maxLength) + '...';
    },
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>
